<script setup lang="ts">
import DSButton from 'primevue/button';
import type { ButtonType } from '@/types/ui.types';

const emit = defineEmits(['back-navigate', 'forward-navigate']);
const props = defineProps({
  backLabel: {
    type: String,
    default: '',
  },
  forwardLabel: {
    type: String,
    default: '',
  },
  backDisabled: {
    type: Boolean,
    default: false,
  },
  forwardDisabled: {
    type: Boolean,
    default: false,
  },
  forwardType: {
    type: String as () => ButtonType,
    default: undefined,
  },
  loading: {
    type: Boolean,
    default: false,
  },
});
</script>
<template>
  <div class="c-form__controls" :class="$style.container">
    <DSButton
      :label="props.backLabel"
      class="p-button-outlined p-button-secondary"
      :class="$style['nav-button']"
      @click="emit('back-navigate')"
      :disabled="props.backDisabled"
    />
    <DSButton
      :label="props.forwardLabel"
      :type="props.forwardType"
      :class="$style['nav-button']"
      @click="emit('forward-navigate')"
      :disabled="props.forwardDisabled"
      :loading="props.loading"
      data-cy="submit-for-review-button"
    />
  </div>
</template>

<style lang="less" module>
.container {
  text-align: center;
  justify-content: center;
  width: 100%;
}

.nav-button {
  min-width: 8rem;
  justify-content: center;
  margin: 0;
  width: 100%;
}
</style>
